/**
 * PowerSaving template component.
 */
import Animator from '@components/elements/animator/animator';
import Container from '@components/atoms/container/powerSavingContainer';
import PowerSavingInfoContainer from '@components/atoms/container/powerSavingInfoContainer';
import PowerSavingSwitcherContainer from '@components/atoms/container/powerSavingSwitcherContainer';
import SettingsInfo from '@components/atoms/text/diskCapacityInfo';
import SettingsTitle from '@components/atoms/text/diskCapacityTitle';
import Switcher from '@components/elements/buttons/ui/powerSavingSwitcher';
import usePowerSavingTemplate from '../lib/usePowerSavingTemplate';
import { selectMenuCollapse } from '@shared/store/slices/menu.slice';
import { useAppSelector } from '@shared/store/hooks';

/**
 * PowerSaving template component.
 */
export default function PowerSavingTemplate() {
  const { callbacks, literals, props } = usePowerSavingTemplate();
  const menuExpanded = !useAppSelector(selectMenuCollapse);
  return (
    <Animator
      id={'powerSavingContainer'}
      type={Animator.Type.SETTING}
      collapse={{ horizontal: menuExpanded }}
    >
      <Container {...callbacks.container}>
        <PowerSavingInfoContainer>
          <SettingsTitle>{literals.title}</SettingsTitle>
          <SettingsInfo
            dangerouslySetInnerHTML={{
              __html: literals.description,
            }}
          />
        </PowerSavingInfoContainer>
        <PowerSavingSwitcherContainer>
          <Switcher {...props.switcher} />
        </PowerSavingSwitcherContainer>
      </Container>
    </Animator>
  );
}
